import type {
  RawOrder,
  Order,
  RawInvoiceLineItem,
  InvoiceLineItem,
  RawInvoice,
  Invoice,
} from './types'

export function parseOrder(rawOrder: RawOrder): Order {
  const { invoiceId, purchaserUserId } = rawOrder

  return {
    invoiceId,
    purchaserUserId,
  }
}

export function parseInvoice(rawInvoice: RawInvoice): Invoice {
  const { id, lineItems } = rawInvoice

  return {
    id,
    lineItems: lineItems.map(parseInvoiceLineItems),
  }
}

export function parseInvoiceLineItems(
  rawInvoiceLineItem: RawInvoiceLineItem,
): InvoiceLineItem {
  const { id } = rawInvoiceLineItem

  return { id }
}
